import React from 'react';
import { Row, Col } from 'react-bootstrap';
import map from 'lodash.map';
import { connect } from 'react-redux';
import * as Maps from '../../../store/map';

function League(props) {
    const handleClick = (e, leagueId) => {
        e.preventDefault();
        props.lsportsActions.prematch.selectLeague(leagueId);
        props.lsportsActions.prematch.setLocationsActive(false);
        props.lsportsActions.prematch.setPrematchActive(true);
    };

    let { leagues } = props;
    let index = 0;

    let drawLeagues = leagues
        ? map(leagues, (item) => {
              let leagueId = item.Id;
              let leagueName = item.Name;
              let count = item.Count;

              index++;
              return (
                  <div key={leagueId}>
                      <Row className="m-0 justify-content-md-center" onClick={(e) => handleClick(e, leagueId)}>
                          <Col xs="1" lg="1" className="p-0"></Col>
                          <Col xs="2" lg="2" md="auto">
                              {index}.
                          </Col>
                          <Col xs="7" lg="7" md="auto" className="p-0">
                              {leagueName}
                          </Col>
                          <Col xs="1" lg="1" md="auto" className="p-0">
                              {count}
                          </Col>
                          <Col xs="1" lg="1" md="auto" className="p-0">
                              <i className="material-icons align-i"> keyboard_arrow_right </i>
                          </Col>
                      </Row>
                      <div className="sports-divider"></div>
                  </div>
              );
          })
        : null;

    return (
        <div className="articlewrap">
            {/* <div className="no-data">No data</div> */}
            {drawLeagues}
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(League);
